import React from "react";
import { RotateCcw } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Erreur d'affichage:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4 px-6 text-center" data-testid="error-boundary">
          <p className="font-display text-xl font-semibold">Oups, un petit souci d'affichage</p>
          <p className="text-sm" style={{ color: "var(--at-text-2)" }}>
            Rien de grave. Rechargez la page pour continuer.
          </p>
          <button
            data-testid="error-reload-btn"
            onClick={() => window.location.reload()}
            className="flex items-center gap-2 rounded-xl px-4 py-2 font-semibold text-white at-press"
            style={{ background: "var(--at-brand)" }}
          >
            <RotateCcw size={18} /> Recharger
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
